import React, { useState } from 'react';
import './App.css';
import { useUi } from './context/UiContext';
import { t } from './i18n';
import Seo from './components/Seo';
import { trackEvent } from './analytics';
import { notify } from './utils/toast';

function Contact() {
  const { lang } = useUi();
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('submitting');
    setError('');
    const formData = new FormData(form);
    const payload = Object.fromEntries(formData.entries());
    try {
      const headers = { 'Content-Type': 'application/json' };
      if (process.env.REACT_APP_CONTACT_API_KEY) {
        headers['x-api-key'] = process.env.REACT_APP_CONTACT_API_KEY;
      }
      const res = await fetch(process.env.REACT_APP_CONTACT_API || '/api/contact', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-store',
        credentials: 'omit',
        headers,
        body: JSON.stringify(payload)
      }).catch((err) => {
        console.error('Contact request failed:', err);
        return null;
      });
      const isOk = !!(res && res.status >= 200 && res.status < 300);
      if (isOk) {
        setStatus('sent');
        try { trackEvent('contact_submit', { ok: true }); } catch (_) {}
        try { form.reset(); } catch (_) {}
        notify.success(t(lang, 'contact.thanks'));
      } else {
        let details = '';
        try {
          if (res) {
            const ct = res.headers.get('content-type') || '';
            if (ct.includes('application/json')) {
              const j = await res.json();
              details = j.error || j.message || JSON.stringify(j).slice(0, 200);
            } else {
              const txt = await res.text();
              details = txt.slice(0, 200);
            }
          }
        } catch (_) {}
        throw new Error(`Failed to send (${res ? `${res.status} ${res.statusText}` : 'network'})${details ? `: ${details}` : ''}`);
      }
      // no-op; reset is handled on success above
    } catch (err) {
      const msg = err && err.message ? err.message : 'Something went wrong. Please try again later.';
      setError(msg);
      notify.error(msg);
      try { trackEvent('contact_submit', { ok: false }); } catch (_) {}
      setStatus('idle');
    }
  }

  return (
    <section className="hero" style={{ paddingTop: 32 }}>
      <Seo title={t(lang, 'contact.title')} description={t(lang, 'contact.subtitle')} />
      <h1 className="hero-title">{t(lang, 'contact.title')}</h1>
      <p className="hero-subtitle">{t(lang, 'contact.subtitle')}</p>
      <form onSubmit={handleSubmit} style={{ maxWidth: 600 }}>
        <div style={{ display: 'grid', gap: 12 }}>
          <input name="name" required placeholder="Your name" className="btn" style={{ padding: 12 }} />
          <input name="email" required type="email" placeholder="Email" className="btn" style={{ padding: 12 }} />
          <input name="company" placeholder="Company" className="btn" style={{ padding: 12 }} />
          <textarea name="message" required placeholder="How can we help?" rows="6" className="btn" style={{ padding: 12 }} />
          <button className="btn primary" disabled={status==='submitting'} type="submit">
            {status === 'submitting' ? t(lang, 'contact.sending') : t(lang, 'contact.send')}
          </button>
          {status === 'sent' && <div role="status">{t(lang, 'contact.thanks')}</div>}
          {error && <div role="alert" style={{ color: 'tomato' }}>{error}</div>}
        </div>
      </form>
    </section>
  );
}

export default Contact;
